import reducer, { authSlice } from './slice';

export const { setLoggedOut } = authSlice.actions;

export * from './thunks';

export default reducer;
